import { IServiceData } from "@/types/strapi";
import LinkButton from "../_atoms/linkbutton";
import RichText from "../_atoms/richtext";

export default function ServiceItem({
	item,
	className,
}: {
	item: IServiceData;
	className?: string;
}) {
	return (
		<article className={className}>
			<h3 className="font-bold text-lg">{item.Header?.h1}</h3>
			{item.short_description && (
				<RichText content={item.short_description} className="my-6" />
			)}
			{!item.single ? (
				<LinkButton
					href={`/services/${item.slug}`}
					text="En savoir plus"
				/>
			) : (
				<LinkButton href="/contact" text="Contactez-moi" />
			)}
		</article>
	);
}
